export const DEFAULT_GROUP_PACKAGE_OPTIONS = {
  criteria: { groupByAvailableDeliveryWindows: true },
}
